
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.692","height":"13.125"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Icon ionic-ios-menu","fill":"#707070"}},[_c('path',{attrs:{"data-name":"Path 8445","d":"M16.955 1.875H.737A.858.858 0 010 .938.858.858 0 01.737.001h16.218a.858.858 0 01.737.938.858.858 0 01-.737.936z"}}),_c('path',{attrs:{"data-name":"Path 8446","d":"M16.955 7.5H.737A.858.858 0 010 6.563a.858.858 0 01.737-.937h16.218a.858.858 0 01.737.938.858.858 0 01-.737.936z"}}),_c('path',{attrs:{"data-name":"Path 8447","d":"M16.955 13.125H.737A.858.858 0 010 12.188a.858.858 0 01.737-.937h16.218a.858.858 0 01.737.938.858.858 0 01-.737.936z"}})])])
          )
        }
      }
    